import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-container">
      <img src={require("./hamsyl.png")} alt="Logo" className="loader-logo" />
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
